import { createClient } from '@supabase/supabase-js'

// Get environment variables
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL!
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY!

// Create Supabase client with your project credentials
export const supabase = createClient(supabaseUrl, supabaseAnonKey)

// No longer in demo mode - using real Supabase
export const isDemoMode = false

// Database types - these should match your actual database schema
export interface Profile {
  id: string
  user_id: string
  username: string | null
  full_name: string | null
  avatar_url: string | null
  bio: string | null
  location: string | null
  website: string | null
  created_at: string
  updated_at: string
}

export interface GuideProfile {
  id: string
  user_id: string
  profile_id: string
  guide_name: string
  description: string | null
  specialties: string[] | null
  languages: string[] | null
  experience_years: number | null
  hourly_rate: number | null
  is_active: boolean
  rating: number | null
  total_reviews: number
  created_at: string
  updated_at: string
}

export interface Pin {
  id: string
  user_id: string
  title: string
  description: string | null
  latitude: number
  longitude: number
  location_name: string | null
  category: string | null
  images: string[] | null
  is_public: boolean
  created_at: string
  updated_at: string
}

// Auth helper functions
export const getCurrentUser = async () => {
  const { data: { user }, error } = await supabase.auth.getUser()
  if (error) throw error
  return user
}

export const signOut = async () => {
  const { error } = await supabase.auth.signOut()
  if (error) throw error
}